import React, { useRef, useEffect } from 'react'
import intlTelInput from 'intl-tel-input';
import FormInput from '../FromInput';

const FormInputTel = ({ onlyCountries, onChange, ...restProps}) => {
  const ref = useRef(null);

  useEffect(() => {
   let iti = intlTelInput(ref.current, {
      onlyCountries: onlyCountries || [],
      nationalMode: false
    })
    ref.current.addEventListener("countrychange", onChange);
    return  () => {
       // eslint-disable-next-line react-hooks/exhaustive-deps
      ref.current.removeEventListener("countrychange", onChange);
      iti.destroy();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormInput {...restProps} ref={ref} onChange={onChange} />
  )
}

export default FormInputTel